import { render, staticRenderFns } from "./Propostas.vue?vue&type=template&id=dc87383e"
import script from "./Propostas.vue?vue&type=script&lang=js"
export * from "./Propostas.vue?vue&type=script&lang=js"
import style0 from "./Propostas.vue?vue&type=style&index=0&id=dc87383e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports